import { createContext, useContext } from 'react';

import { type ToastItem } from '../../components/toast';

// TODO: this shouldnt be a context, it should be a singleton service
export const ToastContext = createContext<{
  toasts: ToastItem[];
  addToast: (toast: ToastItem) => unknown;
}>({
  toasts: [],
  addToast: (_v) => {},
});

export function useToast() {
  const { addToast } = useContext(ToastContext);
  return addToast;
}
